import { ComponentDefinition } from '../../../models';
import { IDeferred } from 'angular';
import { IwtDateFilter } from '../../../filters/date.filter';

export type ApprovalJustificationGetter = (isRejection: boolean, groupName: string, date: string) => angular.IPromise<string>;

class WtApprovalJustificationModalController implements angular.IComponentController {

    getApprovalJustification: ApprovalJustificationGetter;
    title: string;
    comment: string;
    defered: IDeferred<string>;

    static $inject = ['$q', '$translate', 'wtDateFilter'];

    constructor(
        private _$q: angular.IQService,
        private _$translate: angular.translate.ITranslateService,
        private _wtDateFilter: IwtDateFilter
    ) {
    }

    $onInit() {
        this.getApprovalJustification = this.getJustification.bind(this);
    }

    getJustification(isRejection: boolean, groupName: string, date: string): angular.IPromise<string> {
        this.comment = undefined;
        // build title
        const title = isRejection
            ? 'Rejection of  _groupName_ for _date_'
            : 'Approval of _groupName_ for _date_';
        this.title = this._$translate.instant(title, { groupName: groupName, date: this._wtDateFilter(date) });
        // show modal and return promise
        this.defered = this._$q.defer<string>();
        $('#approvalJustificationModal').modal({ keyboard: false, backdrop: 'static' });
        return this.defered.promise;
    }

    validate() {
        this.defered.resolve(this.comment);
        $('#approvalJustificationModal').modal('hide');
    }

    cancel() {
        this.defered.reject();
    }
}

export const wtApprovalJustificationModal: ComponentDefinition = {
    componentId: 'wtApprovalJustificationModal',
    controller: WtApprovalJustificationModalController,
    controllerAs: 'vm',
    template: require('./approvalJustificationModal.component.html'),
    bindings: {
        getApprovalJustification: '=',
        getApprovalJustificationForList: '='
    }
};